import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFD018",
      "fill-rule": "evenodd",
      d: "M0 8h16v4H0z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#E31D1C",
      "fill-rule": "evenodd",
      d: "M0 4h16v4H0z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#272727",
      "fill-rule": "evenodd",
      d: "M0 0h16v4H0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }